import { render, staticRenderFns } from "./ModalDocumentosAdicionar.vue?vue&type=template&id=1a906e04&scoped=true"
import script from "./ModalDocumentosAdicionar.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosAdicionar.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentosAdicionar.vue?vue&type=style&index=0&id=1a906e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a906e04",
  null
  
)

export default component.exports